import { Injectable } from '@angular/core';
import { DateTime, Interval } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class MeetDateService {
  transform(
    value: string[],
    meetTimeFormat: number = 12, // 12 or 24 - old way to do 24 hr time and uk-style dates
    dateStringFallback: string,
  ): string {
    try {
      let returnString = '';
      // http://localhost:4567/meets/34113 - non consecutive days in the same month
      let locale = $localize.locale ?? 'en-US';
      if (meetTimeFormat === 24 && locale === 'en-US') {
        locale = 'en-GB';
      }

      //value = ['2024-10-01', '2024-10-03', '2024-10-04', '2024-10-05']
      if (value.length === 1) {
        returnString = DateTime.fromISO(value[0]).setLocale(locale).toLocaleString(DateTime.DATE_MED);
      } else {
        // split into consecutive intervals
        const intervals: string[][] = [];
        let intervalIdx = 0;
        intervals[intervalIdx] = [];
        intervals[intervalIdx].push(value[0]);
        value.forEach((date, dateIdx) => {
          if (dateIdx > 0) {
            let duration = Interval.fromISO(value[dateIdx - 1] + '/' + date);
            const daysInBetween = duration.length('days');
            if (daysInBetween === 1) {
              intervals[intervalIdx].push(date);
            } else {
              intervalIdx++;
              intervals[intervalIdx] = [];
              intervals[intervalIdx].push(date);
            }
          }
        });

        if (intervals.length === 1) {
          returnString = Interval.fromISO(intervals[0][0] + '/' + intervals[0][value.length - 1]).toLocaleString(
            DateTime.DATE_MED,
            {
              locale,
            },
          );
        } else if (intervals.length > 1) {
          const ret: string[] = [];
          intervals.forEach((interval, intervalIdx) => {
            if (interval.length === 1) {
              ret.push(DateTime.fromISO(intervals[intervalIdx][0]).setLocale(locale).toLocaleString(DateTime.DATE_MED));
            } else {
              ret.push(
                Interval.fromISO(
                  intervals[intervalIdx][0] + '/' + intervals[intervalIdx][intervals[intervalIdx].length - 1],
                ).toLocaleString(DateTime.DATE_MED, {
                  locale,
                }),
              );
            }
          });
          returnString = ret.join(', ');
        } else {
          returnString = '';
        }
      }
      if (returnString === '' || returnString.indexOf('Invalid') > -1) {
        return dateStringFallback;
      }

      return returnString;
    } catch (e) {
      return dateStringFallback;
    }
  }
}
